<!--
/**
 * APCWO customisation for OrangeHRM — Email Templates module.
 *
 * Licensed under the GNU General Public License v2.0 or later, the same terms
 * as OrangeHRM itself. See the LICENSE file at the project root.
 */
-->

<template>
  <div class="apcwo-merge-field-picker">
    <oxd-button
      type="button"
      display-type="secondary"
      icon-name="plus"
      :label="label"
      @click="toggle"
    />
    <div v-if="open" class="apcwo-merge-field-picker__panel">
      <oxd-text v-if="isLoading" tag="p" class="apcwo-merge-field-picker__hint">
        Loading fields…
      </oxd-text>
      <template v-else>
        <div
          v-for="(group, groupName) in grouped"
          :key="groupName"
          class="apcwo-merge-field-picker__group"
        >
          <oxd-text tag="p" class="apcwo-merge-field-picker__group-title">
            {{ groupName }}
          </oxd-text>
          <button
            v-for="field in group"
            :key="field.token"
            type="button"
            class="apcwo-merge-field-picker__item"
            :title="field.placeholder + '  (e.g. ' + field.example + ')'"
            @click="pick(field)"
          >
            {{ field.label }}
            <span class="apcwo-merge-field-picker__token">
              {{ field.placeholder }}
            </span>
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {APIService} from '@ohrm/core/util/services/api.service';

export default {
  name: 'MergeFieldPicker',
  props: {
    label: {
      type: String,
      default: 'Insert field',
    },
  },
  emits: ['insert'],
  setup() {
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/apcwo/email-templates/merge-fields',
    );
    return {http};
  },
  data() {
    return {
      open: false,
      isLoading: false,
      fields: [],
    };
  },
  computed: {
    grouped() {
      return this.fields.reduce((acc, field) => {
        (acc[field.group] = acc[field.group] || []).push(field);
        return acc;
      }, {});
    },
  },
  methods: {
    toggle() {
      this.open = !this.open;
      if (this.open && this.fields.length === 0) {
        this.load();
      }
    },
    load() {
      this.isLoading = true;
      this.http
        .getAll({limit: 0})
        .then((response) => {
          this.fields = response.data.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    pick(field) {
      this.$emit('insert', field.placeholder);
      this.open = false;
    },
  },
};
</script>

<style scoped>
.apcwo-merge-field-picker {
  position: relative;
  display: inline-block;
}
.apcwo-merge-field-picker__panel {
  position: absolute;
  z-index: 20;
  margin-top: 4px;
  min-width: 260px;
  max-height: 320px;
  overflow-y: auto;
  padding: 8px;
  background: #fff;
  border: 1px solid #d9dbdd;
  border-radius: 6px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
}
.apcwo-merge-field-picker__group + .apcwo-merge-field-picker__group {
  margin-top: 8px;
}
.apcwo-merge-field-picker__group-title {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #8c8c8c;
  margin-bottom: 2px;
}
.apcwo-merge-field-picker__item {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 5px 6px;
  border: 0;
  background: transparent;
  text-align: left;
  font-size: 13px;
  cursor: pointer;
  border-radius: 4px;
}
.apcwo-merge-field-picker__item:hover {
  background: #f2f4f5;
}
.apcwo-merge-field-picker__token {
  color: #ff7b1d;
  font-family: monospace;
  font-size: 12px;
}
.apcwo-merge-field-picker__hint {
  font-size: 12px;
  color: #8c8c8c;
}
</style>
